export const config = {
  apiUrl:
    process.env.REACT_APP_API_URL ||
    "http://localhost:1337" ||
    "https://strapi-staging-7edyny5ppq-ew.a.run.app",
};
